import Producent from "../model/producent";
import Producentarendetyp from "../model/producentarendetyp";
import {v4 as uuid } from 'uuid'
import Entity from "../model/entity";
import Kundhandelsetyp from "../model/kundhandelsetyp";

export default class DataModel {
    static #instance: DataModel

    producenter: Producent[]
    producentarendetyper: Producentarendetyp[]
    kundhandelsetyper: Kundhandelsetyp[]

    public static getInstance(): DataModel {
        if (!DataModel.#instance) {
            DataModel.#instance = new DataModel()
        }
        return DataModel.#instance
    }

    private constructor() {
        this.producenter = []
        this.producentarendetyper = []
        this.kundhandelsetyper =[]

        this.#createProducenter()
        this.#createProducentarendetyper()
        this.#createKundhandelsetyper()
    }

    #createProducenter = () => {
        let skv = new Producent('Skatteverket', 'SKV');
        skv.apiUrl = "https://www.skatteverket.se/<NÅGON_URL>"
        skv.dokUrl = "https://www.skatteverket.se/<NÅGON_ANNAN_URL>"
        skv.licens = "Creative Commons - CC1.0"
        skv.format = "JSON"
        skv.version = "4.0"

        let varmdo = new Producent('Värmdö kommun', 'KOMMUN');

        let svall = new Producent('Sundsvalls kommun', 'KOMMUN');

        let bv = new Producent('Bolagsverket', 'BV');

        let tv = new Producent('Tillväxtverket', 'TV');

        let prv = new Producent('Patent och registringsverket', 'PRV');

        this.producenter = [skv, varmdo, svall, bv, tv, prv]
        this.producenter.forEach(this.#setEntityData)
    }

    #createProducentarendetyper = () => {
        const skv: Producent = this.findProducentByNamn('Skatteverket')
        let producentarendetyp1 = new Producentarendetyp(skv, 'Lämna in momsdeklaration', 'MOMS_DEKLARATION');
        this.producentarendetyper.push(producentarendetyp1)

        let producentarendetyp2 = new Producentarendetyp(skv, 'Lämna in inkomstdeklaration 1', 'INK1');
        this.producentarendetyper.push(producentarendetyp2)

        const varmdo: Producent = this.findProducentByNamn('Värmdö kommun')
        let producentarendetyp3 = new Producentarendetyp(varmdo, 'Ansök om bygglov', 'BYGGLOV');
        producentarendetyp3.flowchartRef = 'varmdo-bygglov.png'
        this.producentarendetyper.push(producentarendetyp3)

        const sundsvall: Producent = this.findProducentByNamn('Sundsvalls kommun')
        let producentarendetyp4 = new Producentarendetyp(sundsvall, 'Ansök om bygglov', 'BYGGLOV');

        this.producentarendetyper.push(producentarendetyp4)

        this.producentarendetyper.forEach(this.#setEntityData)
    }

    #createKundhandelsetyper = () => {
        let bygglov = this.findProducentarendetyp('BYGGLOV', 'Värmdö kommun')
        let värmdoBehorighet = 'BYGGLOV, SAMHÄLLSBYGGNAD, KONTROLLANSVARIG'
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Ansökan mottagen', 'ANSOKAN_MOTTAGEN', värmdoBehorighet))
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Handläggare tilldelad', 'HANDLAGGARE', värmdoBehorighet))
        let kompKravs = new Kundhandelsetyp(bygglov, 'Komplettering krävs', 'KOMP_KRAVS', värmdoBehorighet);
        kompKravs.producentarendetKraverKundatgard = true
        kompKravs.beskrivning = "Du behöver skicka in kompletterande uppgifter för ditt bygglovsärende"
        kompKravs.rubrik = "Komplettera"
        this.kundhandelsetyper.push(kompKravs)
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Komplettering mottagen', 'KOMP_MOTTAGEN', värmdoBehorighet))
        let kompPaminn = new Kundhandelsetyp(bygglov, 'Påminnelse komplettering', 'KOMP_PAMINN', värmdoBehorighet);
        kompPaminn.producentarendetKraverKundatgard = true
        kompPaminn.beskrivning = "Glöm inte kompletteringen till ditt bygglovsärende"
        kompPaminn.rubrik = "Påminnelse"
        this.kundhandelsetyper.push(kompPaminn)
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Ansökan avskriven', 'ANSOKAN_AVSKRIVEN', värmdoBehorighet))
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Ansökan komplett', 'ANSOKAN_KOMPLETT', värmdoBehorighet))
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Beslut', 'BESLUT', värmdoBehorighet))
        let faktura = new Kundhandelsetyp(bygglov, 'Faktura', 'FAKTURA', värmdoBehorighet);
        faktura.producentarendetKlart = true
        this.kundhandelsetyper.push(faktura)
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Genomför platsbesök', 'PLATSBESOK', värmdoBehorighet))
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Inhämta yttrande', 'YTTRNDE', värmdoBehorighet))
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Ärendet har tillförts uppgift', 'TILLFORTS', värmdoBehorighet))
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Beslut tas i nämnd', 'NAMND', värmdoBehorighet))
        this.kundhandelsetyper.push(new Kundhandelsetyp(bygglov, 'Preliminär bedömning avslag', 'PREL_AVSLAG', värmdoBehorighet))

        let skv_moms = this.findProducentarendetyp('MOMS_DEKLARATION', 'Skatteverket')
        let skv_behorighet = 'MOMS, BESKATTNING, FTG, PRIV'
        let skv_sprak = 'sv, en'
        let lamnaIn = new Kundhandelsetyp(skv_moms, 'Lämna in momsdeklaration för {PERIODDISP}', 'MOMSSV_DEKLPERIOD_OPPNAS_V1', skv_behorighet, skv_sprak);
        lamnaIn.producentarendetKraverKundatgard = true
        this.kundhandelsetyper.push(lamnaIn)
        this.kundhandelsetyper.push(new Kundhandelsetyp(skv_moms, 'Momsdeklaration för {PERIODDISP} har lämnats in', 'MOMSSV_DEKLPERIOD_DEKLARERAD_V1', skv_behorighet, skv_sprak))

        this.kundhandelsetyper.forEach(this.#setEntityData)
    }

    findProducentByNamn = (namn: string): Producent => {
        return this.producenter.filter((p: Producent) => p.namn === namn)[0]
    }

    findProducentarendetyp = (producentarendetypIdentifierare: string, producentNamn: string): Producentarendetyp => {
        return this.producentarendetyper.filter((p: Producentarendetyp) => {
            return p.identifierare === producentarendetypIdentifierare
        }).filter((p:Producentarendetyp) => {
            return p.producent.namn === producentNamn
        })[0]
    }

    #setEntityData = (e : Entity) => {
        e.dbId = uuid()

        let dayInterval = 1000;

        const createdNum = Math.floor(Math.random() * dayInterval)
        const updatedNum = Math.max(createdNum - Math.floor(Math.random() * dayInterval), 0)

        e.createdAt = daysAgo(createdNum)
        e.updatedAt = daysAgo(updatedNum)
    }

}


const daysAgo = (days: number) => {
    const randomBetween = (min: number, max: number) => {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    var date = new Date()
    date.setDate(date.getDate() - days)

    date.setHours(randomBetween(9, 16))
    date.setMinutes(randomBetween(0, 59))
    date.setSeconds(randomBetween(0, 59))

    return date
}
